import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-briefcase-svg-icon',
    template: `./duotone-briefcase-svg-icon.component.html`,
    standalone: false
})

export class DuotoneBriefcaseSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
